<template>
        <div class="flex flex-col lg:flex-row flex-wrap">
            <token-package
                :tokenPackage="tokenPackage" :user="user" v-for="(tokenPackage, index) in packages"
                           v-model="selectedTokenPackage" :key="index" @tokenPackageSelected="setSelectedTokenPackage"
                           @openPurchaseMenu="openPurchaseMenu" class="mb-4 lg:mr-4 in-out delay-150 duration-300
                            col-span-1 col-sm transition-all duration-900 ease-in-out col-sm"/>
        </div>
</template>

<script>
	import { ref, onMounted, computed } from 'vue'
	import RacingStarsIcon from '@/Global/RacingStarsIcon'
	import TokenPackage from './TokenPackage'

	export default {
		props: {
			user: {
				type: Object,
				default: {}
			},
			packages: {
				type: Array,
				default: []
			}
		},

		emits: ['openPurchaseMenu'],

		components: {
			RacingStarsIcon,
			TokenPackage
		},

		setup(props, { emit }) {
			const selectedTokenPackage = ref()
			const windowWidth = ref(window.innerWidth)

			const setSelectedTokenPackage = (index) => {
				selectedTokenPackage.value = index
                console.log(selectedTokenPackage);
			}

			const openPurchaseMenu = (index) => {
				emit('openPurchaseMenu', index)
			}


			const setWindowDimensions = () => {
				windowWidth.value = window.innerWidth
			}

			const isMobile = computed(() => {
				if (windowWidth.value < 1024) {
					return true
				}

				return false
			})

			onMounted(() => {
				setWindowDimensions()

				window.addEventListener('resize', setWindowDimensions)
			})

			return {
				selectedTokenPackage,
				setSelectedTokenPackage,
				openPurchaseMenu,
				isMobile,
			}

		}
	}
</script>
